module.exports = __webpack_public_path__ + "img/aeo_logo.7023b33f.png";